import { Nav } from '@/components/layout/Nav'
import { Footer } from '@/components/layout/Footer'
import { FlashBanner } from '@/components/ui/FlashBanner'

interface PublicLayoutProps {
  children: React.ReactNode
}

/**
 * The frame of the public pages (landing, about), as AppLayout is for signed-in ones.
 * It carries the flash too: a request the server refuses is redirected here with an
 * alert (render_forbidden), and without the banner that alert was never shown.
 * Server-rendered (ADR-003); FlashBanner appears only after hydration.
 */
export function PublicLayout({ children }: PublicLayoutProps) {
  return (
    <div className="min-h-dvh bg-page-bg font-sans text-body transition-colors duration-500">
      <Nav />
      <main id="main-content" tabIndex={-1} className="outline-none">
        {children}
      </main>
      <Footer />
      <FlashBanner />
    </div>
  )
}
